module.exports = __webpack_public_path__ + "img/steam-turbine-H-shadow.3f97c168.png";